import React, {useEffect} from "react";
import { createState, useState } from "@hookstate/core";
import {  useQueryClient, useQuery } from "react-query"
import {USER} from "./TYPES";
import {getUser} from "./index";
export const userStore = createState({loggedIn:false, user:null, googleMaps:"idle"});

export function useUserStore(){
	const {data, status} = useQuery(USER.name, getUser);
	console.log({data, status});
	useEffect(()=>{
		if(data){
			userStore.set(p => ({...p, user:data, loggedIn:true, status:"success"}));
		}else{
			userStore.set(p => ({...p,status:"success", loggedIn:false}));
		}
	},[data, status]);

	return {user: data, status};

}